{
  document.addEventListener("DOMContentLoaded", function () {
    const videoBoxes = document.querySelectorAll(".why-choose-video-box");
    let currentlyPlaying = null;
    videoBoxes.forEach((box) => {
      const video = box.querySelector("video");
      const playBtn = box.querySelector(".video-playBtn");
      playBtn.addEventListener("click", function () {
        if (currentlyPlaying === video) {
          video.pause();
          box.classList.remove("active");
          playBtn.classList.remove("active");
          currentlyPlaying = null;
          return;
        }
        if (currentlyPlaying) {
          currentlyPlaying.pause();
          currentlyPlaying
            .closest(".why-choose-video-box")
            .classList.remove("active");
          currentlyPlaying
            .closest(".why-choose-video-box")
            .querySelector(".video-playBtn")
            .classList.remove("active");
        }
        video.play();
        box.classList.add("active");
        playBtn.classList.add("active");
        currentlyPlaying = video;
      });
      video.addEventListener("pause", function () {
        if (currentlyPlaying === video) {
          box.classList.remove("active");
          playBtn.classList.remove("active");
          currentlyPlaying = null;
        }
      });
      video.addEventListener("ended", function () {
        box.classList.remove("active");
        playBtn.classList.remove("active");
        currentlyPlaying = null;
      });
    });
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".videos_sliders");
      MultipleSliders.forEach((slider, index) => {
        const paginationEl = document.createElement("div");
        paginationEl.classList.add("swiper-pagination");
        paginationEl.classList.add(`pagination-${index}`);
        slider.appendChild(paginationEl);
        new Swiper(slider, {
          direction: "horizontal",
          grabCursor: true,
          speed: 1000,
          pagination: {
            el: `.pagination-${index}`,
            clickable: true,
          },
          breakpoints: {
            150: {
              slidesPerView: 2.4,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 3.2,
              spaceBetween: 10,
            },
            769: {
              slidesPerView: 3.4,
              spaceBetween: 10,
            },
            1025: {
              slidesPerView: 3.6,
              spaceBetween: 10,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}

document.addEventListener("DOMContentLoaded", function () {
  Fancybox.bind("[data-fancybox='size-guide']", {});
});